<template>
  <div class="container mt-4">
    <h3>Add Product</h3>

    <div class="card p-3">

      <div class="mb-3">
        <label>Product Name</label>
        <input type="text" class="form-control" v-model="product.name" />
      </div>

      <div class="mb-3">
        <label>Purchase Price</label>
        <input type="number" class="form-control" v-model.number="product.purchasePrice" />
      </div>

      <div class="mb-3">
        <label>Selling Price</label>
        <input type="number" class="form-control" v-model.number="product.sellingPrice" />
      </div>

      <div class="mb-3">
        <label>Category</label>
        <select class="form-control" v-model.number="product.categoryId" @change="populateAttributes">
          <option disabled value="">-- Select Category --</option>
          <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
        </select>

        <button class="btn btn-link p-0" @click="openCategoryModal">
          + Add Category
        </button>
      </div>

      <div class="mb-3" v-if="attributeInputs.length">
        <label>Attributes</label>

        <div v-for="(attr, index) in attributeInputs" :key="index" class="mb-2">
          <label class="form-label">{{ attr.name }}</label>
          <input :type="attr.type === 'number' ? 'number' : 'text'" 
                 class="form-control" 
                 v-model="attr.value" />
        </div>
      </div>

      <div class="mb-3">
        <label>Product Images</label>
        <input type="file" multiple class="form-control" @change="handleImageChange" />
        <div class="d-flex flex-wrap gap-2 mt-2">
          <div v-for="(image, index) in product.images" :key="index" class="position-relative">
            <img :src="image.preview" class="img-thumbnail"
                 style="width: 120px; height: 120px; object-fit: cover;" />
            <button @click="removeImage(index)"
              class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1">&times;</button>
          </div>
        </div>
      </div>

      <div class="text-end mt-3">
        <button class="btn btn-secondary me-2" @click="$router.back()">Cancel</button>
        <button class="btn btn-success" @click="saveProduct">Save Product</button>
      </div>
    </div>

    <!-- Keep category modal -->
    <CategoryModal ref="categoryModal" @category-added="onCategoryAdded" />
  </div>
</template>

<script>
import { productApi, categoryApi } from "@/api/productApi";
import CategoryModal from "@/components/modals/CategoryModal.vue";
import notify from "@/utils/swal.js";

export default {
  components: { CategoryModal },
  data() {
    return {
      product: {
        name: '',
        purchasePrice: 0,
        sellingPrice: 0,
        categoryId: '',
        images: []
      },
      categories: [],
      attributeInputs: []
    };
  },
  async created() {
    const res = await categoryApi.getAll();
    this.categories = res.data;
  },
  methods: {
    populateAttributes() {
      const selected = this.categories.find(c => c.id === this.product.categoryId);
      this.attributeInputs = selected?.attributes.map(attr => ({
        categoryAttributeId: attr.id,
        name: attr.name,
        type: attr.type,
        value: ''
      })) || [];
    },
    handleImageChange(e) {
      const files = e.target.files;
      for (let f of files) {
        this.product.images.push({
          file: f,
          preview: URL.createObjectURL(f)
        });
      }
    },
    removeImage(i) {
      URL.revokeObjectURL(this.product.images[i].preview);
      this.product.images.splice(i, 1);
    },
    openCategoryModal() {
            this.$router.push({
        path: "/form",   // <-- The dynamic form route
        query: { menu: "New Category" }
      });
    },
    onCategoryAdded(category) {
      this.categories.push(category);
    },
    async saveProduct() {
      if (!this.product.name || !this.product.categoryId) {
        return notify.warning("Product name and category required");
      }

      const fd = new FormData();
      fd.append("name", this.product.name);
      fd.append("purchasePrice", this.product.purchasePrice);
      fd.append("sellingPrice", this.product.sellingPrice);
      fd.append("categoryId", this.product.categoryId);
      fd.append("stock", 0);

      this.attributeInputs.forEach((attr, i) => {
        fd.append(`attributes[${i}].categoryAttributeId`, attr.categoryAttributeId);
        fd.append(`attributes[${i}].value`, attr.value);
      });

      this.product.images.forEach(img => {
        fd.append("images", img.file, img.file.name);
      });

      try {
        const res = await productApi.create(fd);
        notify.success("Product created!", res.data.name);
              this.$router.push({
        path: "/form",   // <-- The dynamic form route
        query: { menu: "Goods Receipt" }
      });
      } catch (e) {
        notify.error("Failed to save product");
      }
    }
  }
};
</script>
